function ManageBtnArea(props: any) {
  let myProps = {
    setWriteState: () => { },
    goDelete: () => { },
    open_multy_modify_popup: (inData:any) => { },
    ...props
  };

  return (
    <div style={{ position: "relative", textAlign: "right" }}>
      <button className="btn btn-sky ml-1" onClick={() => { myProps.setWriteState(); }}>신규</button>
      <button className="btn btn-red ml-1" onClick={myProps.goDelete}>삭제</button>
      <button className="btn btn-sky ml-1" onClick={()=>{myProps.open_multy_modify_popup({});}}>일괄수정</button>
    </div>
  );
};
export default ManageBtnArea;